import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router } from '@angular/router';
import { RepoService, Repo } from '../../services/repo.service';
import { OauthService, UserInfo } from '../../services/oauth.service';
import { UserSettingsService } from '../../services/user-settings.service';
import { CreateRepoComponent } from '../../components/dialogue/create-repo/create-repo.component';

@Component({
  selector: 'app-repositories',
  standalone: true,
  imports: [CommonModule, CreateRepoComponent],
  templateUrl: './repositories.component.html',
  styleUrl: './repositories.component.css'
})
export class RepositoriesComponent implements OnInit {
  repositoriesList: Repo[] = [];
  user: UserInfo | null = null;
  selectedRepoId: string | null = null;

  constructor(private router: Router, private repoService: RepoService, private oauth: OauthService, private userSettings: UserSettingsService) {}

  ngOnInit() {
    this.getRepos();
    this.oauth.getUser().then((user: UserInfo | null) => this.user = user);
  }

  async getRepos() {
    this.repositoriesList = await this.repoService.getRepos();
    // console.log(this.repositoriesList);
  }

  onRepositoryClick(repository: Repo) {
    // console.log('repository', repository);
    this.selectedRepoId = repository.id;
  }
}
